
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { i18n } from "@/i18n";
import {
  ISolCustomerCurrency,
  ISolCustomerDenomination,
  ISolCustomerDenominationQuantity,
} from "@/entities";
import IconTrash from "@/components/common/icon/IconTrash.vue";

@Component({
  name: "denominations-table",
  components: {
    IconTrash,
  },
})
export default class DenominationsTable extends Vue {
  @Prop({ required: false, default: {} }) currency!: ISolCustomerCurrency;
  @Prop({ required: false, default: [] }) denominations!: ISolCustomerDenomination[];
  @Prop({ required: false, default: [] })
  denominationsQuantities!: ISolCustomerDenominationQuantity[];
  @Prop({ required: false, default: false }) readonly!: boolean;

  get denominationRows(): {
    denomination?: ISolCustomerDenomination;
    denominationQauntity: ISolCustomerDenominationQuantity;
  }[] {
    return this.denominationsQuantities
      .filter(
        (dq) =>
          this.denominations.find((d) => d.id === dq.denominationId) && dq.denominationQuantity
      )
      .map((dq) => {
        const row: {
          denomination?: ISolCustomerDenomination;
          denominationQauntity: ISolCustomerDenominationQuantity;
        } = {
          denomination: this.denominations.find((d) => d.id === dq.denominationId),
          denominationQauntity: dq,
        };
        return row;
      });
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "denomination.description",
        label: i18n.t("label.denomination") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first table-cell-middle align-middle",
      },
      {
        key: "amount",
        label: i18n.t("column.amount") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (
          _value: number,
          _key: string,
          item: {
            denomination?: ISolCustomerDenomination;
            denominationQauntity: ISolCustomerDenominationQuantity;
          }
        ): number => {
          return (
            Math.round(
              item.denominationQauntity.denominationQuantity! *
                (item.denomination?.value || 0) *
                100
            ) / 100
          );
        },
      },
      {
        key: "denominationQauntity.denominationQuantity",
        label: i18n.t("label.quantity") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last",
      },
    ];
  }

  removeDenomination(row: {
    denomination?: ISolCustomerDenomination;
    denominationQauntity: ISolCustomerDenominationQuantity;
  }): void {
    row.denominationQauntity.denominationQuantity = null;
  }
}
